import { styled } from '@arpeggi/ui'
import { FC } from 'react'
import Text from '../../../__legacy__/components/core/Text/Text'

const StyledText = styled(Text, {
  textOverflow: 'ellipsis',
  overflow: 'hidden'
})

interface Props {
  link: string
}

export const RedirectAnchor: FC<Props> = ({ link }) => {
  return (
    <StyledText size="14">
      <a href={link} target="_blank">
        {link}
      </a>
    </StyledText>
  )
}
